
import { BrowserRouter as Router } from "react-router-dom";
import { useState } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

import { ThemeProvider } from "./context/ThemeContext";
import { AppRoutes } from "./components/AppRoutes";

function App() {
  const [user, setUser] = useState(null);

  const handleLogin = (userData) => {
    console.log("User logged in:", userData);
    setUser(userData);
    // Optionally save token for API calls:
    localStorage.setItem("token", userData.token);
  };

  return (
    <ThemeProvider>
      <div>
        <Router>
          <AppRoutes user={user} onLogin={handleLogin} />
        </Router>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
